'use strict'

export default class KsAnimate {
    constructor(index, frameAmount) {
        this.index = index;
        this.content = $(`.content${index}`);
        this.layer = this.content.find(`.sub2 svg .layer1`);
        this.auto = false;
        this.frameIndex = 0;
        this.frameAmount = frameAmount;
        this.createEvents();
        this.arrowLayout();
        this.hide();
    }
    show() {
        this.content.insertBefore('.questions');
        this.content.show();
        this.arrowLayout();
        this.goToFrame("1");
        // no auto for now, it's only disturbing
        //setTimeout(() => {
            //this.nextFrame();
            //this.startAuto();
        //}, 1000);
    }
    hide() {
        this.stopAuto();
        this.content.detach();
    }
    startAuto() {
        this.auto = true;
        this.frameIteration = setInterval(() => {
            this.nextFrame();
        }, 9000);
    }
    stopAuto() {
        clearInterval(this.frameIteration);
    }
    nextFrame() {
        this.frameIndex = Math.max((this.frameIndex+1)%(this.frameAmount+1),1);
        this.goToFrame(this.frameIndex);
    }
    goToFrame(frameIndex) {
        this.frameIndex = parseInt(frameIndex);
        this.layer.attr('class',`layer1 layer frame${this.frameIndex}`);
        this.controlContent(frameIndex);
        window.staticEvents.emit('trackEvent',['kundenSchema',`index ${this.index}`,`show frame ${this.frameIndex}`]);
    }
    getFrameIndex() {
        return this.frameIndex;
    }
    controlContent(frameIndex) {
            const p = this.content.find(`.sub1_${frameIndex} > p`);
            const target = '.'+p.attr('data-target');
            $('.content_text').not(target).not('arrow').removeClass('active');
            $('.sub1_s').not(p.parent()).removeClass('active');
            $('svg.content_text').not('.active').addClass('active');
            $(target).not('.active').addClass('active');
            p.parent().not('.active').addClass('active');
    }
    createEvents() {
        $(`.content${this.index} .sub1_s`).hover((e) => {
            const frame = $(e.currentTarget).children('p').attr('data-frame'); 
            this.stopAuto();
            this.goToFrame(frame);
            this.auto = false;
            window.staticEvents.emit('trackAction',['kundenSchema',this.index,frame]);
        },(e) => {
            this.auto = true;
        });
        window.staticEvents.addListener('resize', () => {
            this.arrowLayout();
        });
    }
    arrowLayout() {
        // placeholder
    }
    arrowFiveLayout() {
        const a1 = this.content.find('.ar_1').first();
        const b1 = this.content.find('.sub1_1').first();
        const a2 = this.content.find('.ar_2').first();
        const b2 = this.content.find('.sub1_2').first();
        const a3 = this.content.find('.ar_3').first();
        const b3 = this.content.find('.sub1_3').first();
        const a4 = this.content.find('.ar_4').first();
        const b4 = this.content.find('.sub1_4').first();
        const a5 = this.content.find('.ar_5').first();
        const b5 = this.content.find('.sub1_5').first();

        a1.css('left', b1.width() - (a1.width() * 0.5) + 2);
        a1.css('top', b1.height() * 0.5 - (a1.height() * 0.5) - 2);

        a2.css('left', (b1.width() + b2.width()) - (a2.width() * 0.5) + 2);
        a2.css('top', b2.height() * 0.5 - (a2.height() * 0.5) - 2);

        a3.css('left', b1.width() + b2.width() + (b3.width() * 0.5) - (a3.width() * 0.5));
        a3.css('top', b2.height() - (a3.height() * 0.5) + 2);

        a4.css('left', b5.width() - (a4.width() * 0.5) - 2);
        a4.css('top', b1.height() + (b5.height() * 0.5) - (a2.height() * 0.5) - 4);

        a5.css('left', (b1.width() * 0.5) - (a5.width() * 0.5));
        a5.css('top', b1.height() - (a5.height() * 0.5));
    }
}
export class KsAnimate1 extends KsAnimate {
    constructor() {
        super('1', 4);
    }
}
export class KsAnimate2 extends KsAnimate {
    constructor() {
        super('2', 5);
    }
    arrowLayout() {
        super.arrowFiveLayout();
    }
}
export class KsAnimate3 extends KsAnimate {
    constructor() {
        super('3', 5);
    }
    arrowLayout() {
        super.arrowFiveLayout();
    }
}
export class KsAnimate4 extends KsAnimate {
    constructor() {
        super('4', 5);
    }
    arrowLayout() {
        super.arrowFiveLayout();
    }
}
